import React, { useEffect, useRef, useState } from 'react';
import Save from "../../assets/save.svg";
import { Modal } from 'flowbite-react';
import AttachmentModalProps from "./AttachmentModalProps";
import { PdfViewer } from './PdfViewer';
import PaginationControls from './RenderFileFooter';

export const RenderPdf = ({ media, file_obj, disabled, onRemove, component, isReplyMessage }: AttachmentModalProps) => {
    const modalBodyRef = useRef<HTMLDivElement | null>(null);
    const [selectedFile, setSelectedFile] = useState<string | null>(null);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState<number | null>(null);

    const openModal = (url: string) => {
        setSelectedFile(url);
    };

    const closeModal = () => {
        setSelectedFile(null);
    };

    const handlePagesCount = (count: number | null) => {
        setPages(count);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalBodyRef.current && !modalBodyRef.current.contains(event.target as Node)) {
                closeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            {media && component({
                media: media, onClick: () => openModal(media.file),
                isReplyMessage: isReplyMessage
            })}
            {file_obj && component({
                file_obj: file_obj,
                disabled: disabled,
                onRemove: onRemove,
                isReplyMessage: isReplyMessage,
                onClick: () => openModal(file_obj.media_info.file)
            })}
            {/* Модальное окно на весь экран */}
            <Modal
                size={'6xl'}
                ref={modalBodyRef}
                style={{
                    transformOrigin: '0 0'
                }}
                show={selectedFile !== null}
                onClose={closeModal}>
                <Modal.Header
                    className={"overflow-hidden whitespace-pre-wrap break-word-only-long"}>
                    {media && media.original_name || file_obj && file_obj.media_info.original_name}
                </Modal.Header>
                <Modal.Body className="w-full">
                    {selectedFile &&
                        <PdfViewer selectedFile={selectedFile} page={page} setPages={handlePagesCount} />}
                </Modal.Body>
                <Modal.Footer>
                    <PaginationControls
                        page={page}
                        pages={pages ?? 0}
                        setPage={setPage}
                        media={media}
                        file_obj={file_obj}
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
}